import { Badge } from "@/components/ui/badge";

export const STATUS = { aktif: "Aktif", beklemede: "Beklemede", tamamlandi: "Tamamlandı" };
const TONE = { aktif: "bg-emerald-50 text-emerald-700 border-emerald-200", beklemede: "bg-amber-50 text-amber-700 border-amber-200", tamamlandi: "bg-slate-100 text-slate-700 border-slate-300" };

export const StatusBadge = ({ status, testid }) => (
  <Badge variant="outline" className={`text-[11px] font-semibold ${TONE[status] || ""}`} data-testid={testid}>{STATUS[status] || status}</Badge>
);

export const newKey = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const fileSize = (n) => (n >= 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);

export const ACCEPT = ".pdf,.jpg,.jpeg,.png,.xls,.xlsx,.doc,.docx";
export const MAX_FILE = 20 * 1024 * 1024;

export function checkFiles(files) {
  const bad = files.find((f) => !/\.(pdf|jpe?g|png|xlsx?|docx?)$/i.test(f.name) || f.size > MAX_FILE);
  if (!bad) return null;
  return bad.size > MAX_FILE ? `${bad.name}: en fazla 20 MB` : `${bad.name}: yalnız PDF, JPG, PNG, XLS, XLSX, DOC, DOCX`;
}

const TYPE_TONE = { malzeme: "bg-sky-50 text-sky-800 border-sky-200", iscilik: "bg-orange-50 text-orange-800 border-orange-200", hizmet: "bg-violet-50 text-violet-800 border-violet-200", belirtilmemis: "bg-slate-50 text-slate-500 border-dashed border-slate-300" };
export const TYPE_LABEL = { malzeme: "Malzeme", iscilik: "İşçilik", hizmet: "Hizmet", belirtilmemis: "Belirtilmemiş" };

export const TypeBadge = ({ type, label, testid }) => (
  <Badge variant="outline" className={`text-[10px] font-semibold whitespace-nowrap ${TYPE_TONE[type] || ""}`} data-testid={testid}>{label || TYPE_LABEL[type] || type}</Badge>
);
